import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SVGElement from './SVGElement';
import colors from '../../styling/colors';

export default class User extends Component {
  static propTypes = {
    className: PropTypes.string,
    height: PropTypes.string,
    strokeColor: PropTypes.string,
    width: PropTypes.string,
  };

  static defaultProps = {
    height: '1.5rem',
    strokeColor: colors('Lapel'),
    width: '1.5rem',
  };

  render() {
    const { className, height, strokeColor, width } = this.props;

    return (
      <SVGElement
        className={className}
        height={height}
        viewBox="0 0 24 24"
        width={width}
      >
        <path
          fill={strokeColor}
          d="M12,12.48A5.24,5.24,0,1,0,6.76,7.24,5.25,5.25,0,0,0,12,12.48ZM12,3A4.29,4.29,0,1,1,7.71,7.24,4.3,4.3,0,0,1,12,3Z"
        />
        <path
          fill={strokeColor}
          d="M17.55,12.07a.48.48,0,0,0-.14,1A4.33,4.33,0,0,1,21,17.29v3.29a.48.48,0,0,1-.48.48H3.43A.48.48,0,0,1,3,20.57V17.26A4.36,4.36,0,0,1,6.6,13a.48.48,0,1,0-.14-1A5.31,5.31,0,0,0,2,17.26v3.31A1.43,1.43,0,0,0,3.43,22H20.57A1.43,1.43,0,0,0,22,20.57V17.26A5.27,5.27,0,0,0,17.55,12.07Z"
        />
      </SVGElement>
    );
  }
}
